"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFromTemplateArtifact = void 0;
const cloneUtils_1 = require("../cloneUtils");
const cloneFromTemplateArtifact = (params) => {
    return (0, cloneUtils_1.unSupportedClone)(params);
};
exports.cloneFromTemplateArtifact = cloneFromTemplateArtifact;
//# sourceMappingURL=clone.js.map